import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { colors } from '../css/revenueItems.styles';
import { memberRowActionLinkSx } from '../css/daoMemberModal.styles';

/**
 * Accent text-link actions for table rows (same look as DAO Members).
 * @param {{ key: string, label: string, onClick: () => void }[]} actions
 * @param {string|null} activeKey — loading key; other actions disabled while set
 */
const MemberRowActions = ({ actions, activeKey }) => {
  const busy = Boolean(activeKey);
  if (!actions?.length) return null;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        columnGap: 0.75,
        rowGap: 0.5,
      }}
    >
      {actions.map((action, index) => {
        const isLoading = activeKey === action.key;
        return (
          <React.Fragment key={action.key}>
            {index > 0 && (
              <Typography
                component="span"
                sx={{ color: colors.textSecondary, fontSize: '0.875rem', lineHeight: 1.4 }}
              >
                ·
              </Typography>
            )}
            <Button
              disableRipple
              disabled={(busy && !isLoading) || action.disabled}
              onClick={(e) => {
                e.stopPropagation();
                if (typeof action.onClick === 'function') action.onClick(e);
              }}
              sx={memberRowActionLinkSx}
            >
              {isLoading ? (
                <CircularProgress size={14} sx={{ color: colors.accent, display: 'block' }} />
              ) : (
                action.label
              )}
            </Button>
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default MemberRowActions;
